import React from 'react'
import HomePage from '../home'
import Formsy from 'formsy-react'
import MyPage from '../../components/MyPage'
import MyInput from '../../components/MyInput'
import ErrorMessage from '../../components/errormessage'
import { actions } from '../../redux/modules/challengeSubtopics'
import SelectRecommendedDiagnosesModal from '../SelectRecommendedDiagnoses'

class ChallengeSubtopicsEdit extends MyPage {
  constructor (props) {
    super(props)
    this.state = {
      errorMessage: '',
      canSubmit: false,
      showValidationErrors: false,
      isLoading: true,
      openDialog: false
    }
  }

  getObject = () => {
    if (this.props.location.state && this.props.location.state.obj) {
      const object = this.props.location.state.obj

      // Set Selected Recommended Diagnoses
      if (object && object.diagnoses) {
        object.selectedDiagnoses = object.diagnoses
          .map(({ diagnosisId, relevance }) => ({ _id: diagnosisId, relevance }))
      }

      this.setState({
        object,
        isLoading: false
      })
    } else {
      this.setState({
        object: {
          title: '',
          diagnoses: [],
          selectedDiagnoses: []
        },
        isLoading: false
      })
    }
  }

  getTexts = () => {
    return {
      pageTitle: 'Challenge Subtopic'
    }
  }

  handleChange = e => {
    e.preventDefault()
    const target = e.target
    this.setState(state => {
      return {
        object: {
          ...state.object,
          [target.id]: target.value
        }
      }
    })
  }

  cancel = e => {
    e.preventDefault()
    this.props.router.push('/challenge-subtopics-list')
  }

  save = async e => {
    e.preventDefault()
    if (window.confirm('Are you sure you want to save this Challenge Subtopic?')) {
      const result = await actions.save(this.state.object)
      if (result) {
        if (!result.success) {
          this.setState({ errorMessage: result.error })
        } else {
          this.cancel(e)
          this.setState({ errorMessage: '' })
        }
      }
    }
  }

  /**
   * SelectRecommendedDiagnosesModal callback
   */
  onCloseSelectDiagnoses = () => {
    this.setState(state => {
      const { selectedDiagnoses = [] } = state.object

      return {
        object: {
          ...state.object,
          diagnoses: selectedDiagnoses
        }
      }
    })
  }

  componentDidMount () {
    this.getObject()
  }

  render () {
    const style = { color: 'red' }

    return (
      <HomePage router={this.props.router}>
        <div className="devices-page-wrapper">
          <ErrorMessage text={this.state.errorMessage} />
          <h3>{this.getTexts().pageTitle}</h3>
          {!this.state.isLoading && (
            <Formsy
              className="create-device-form"
              onValidSubmit={this.submit}
              onInvalidSubmit={() =>
                this.setState({ showValidationErrors: true })
              }
              onValid={() => this.setState({ canSubmit: true })}
              onInvalid={() => this.setState({ canSubmit: false })}
            >
              <div className="create-device-row">
                <label>
                  Title <span style={style}>*</span>
                </label>
                <MyInput
                  id="title"
                  name="title"
                  classNameDiv="create-branch-row"
                  className="create-device-input"
                  autocomplete="off"
                  value={this.state.object.title}
                  onChange={this.handleChange}
                  required
                  showError={this.state.showValidationErrors}
                />
              </div>
              <div className='create-device-row'>
                <label>Recommended Diagnoses</label>
                <SelectRecommendedDiagnosesModal
                  object={this.state.object}
                  onExit={this.onCloseSelectDiagnoses} />
              </div>
              <button
                className="btn green mr-2"
                type="submit"
                onClick={this.state.canSubmit ? this.save : undefined}
              >
                Save
              </button>
              <button
                className="btn blue mr-2"
                type="button"
                onClick={this.cancel}
              >
                Cancel
              </button>
            </Formsy>
          )}
        </div>
      </HomePage>
    )
  }
}

export default ChallengeSubtopicsEdit
